import {
  Breakpoints,
  type TagColor,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import { OrganizationType } from '../common/OrganizationImg';
import OrganizationTag, {
  type OrganizationTagDetails,
} from '../common/OrganizationTag';

import type { CompanyTagCoachFragment } from './__generated-gql-types__/CompanyTag.generated';

interface CompanyTagProps {
  coach?: CompanyTagCoachFragment;
  selectedCompanyTagDetails?: OrganizationTagDetails;
  tagColor?: TagColor;
  className?: string;
}

const CompanyTag: React.FC<CompanyTagProps> = ({
  coach,
  selectedCompanyTagDetails,
  tagColor,
  className,
}) => {
  const isMd = useMediaQuery(Breakpoints.MD);

  const workedAt =
    coach?.professionalExperiences?.find(
      (experience) => experience.isFeatured,
    ) ?? coach?.professionalExperiences?.[0];
  const companyTagDetails: Nullable<OrganizationTagDetails> =
    selectedCompanyTagDetails ??
    (workedAt
      ? {
          organization: {
            name: workedAt.company.name,
            logoLink: workedAt.company.logoLink,
          },
          text: `${
            isMd ? `Work${workedAt.endAt?.year ? 'ed' : 's'} at ` : ''
          }${workedAt.company.name}`,
          tagColor,
        }
      : null);

  return companyTagDetails?.organization ? (
    <OrganizationTag
      className={className}
      tagDetails={companyTagDetails}
      type={OrganizationType.COMPANY}
    />
  ) : null;
};

export default CompanyTag;
